import { motion } from "framer-motion";
import { Apple, Play } from "lucide-react";
import { RevealText } from "./RevealText";

const StoreButton = ({ href, icon: Icon, top, bottom, testid }) => {
  const external = href.startsWith("http");
  return (
    <a
      href={href}
      {...(external ? { target: "_blank", rel: "noreferrer" } : {})}
      data-testid={testid}
      className="group inline-flex items-center gap-3 rounded-2xl bg-brand-inverse text-brand-dark px-6 py-4 min-w-[200px] hover:bg-brand-bg transition-colors duration-300 active:scale-95"
    >
      <Icon size={26} className="shrink-0" />
      <span className="flex flex-col leading-none text-left">
        <span className="text-[11px] text-brand-muted">{top}</span>
        <span className="text-lg font-display tracking-tight">{bottom}</span>
      </span>
    </a>
  );
};

export const Download = () => {
  return (
    <section
      id="scarica"
      data-testid="download-section"
      className="relative py-4 bg-brand-surface"
    >
      <div className="mx-auto max-w-[1400px] px-4 sm:px-8">
        <div className="relative overflow-hidden rounded-[2rem] bg-brand-primary px-6 sm:px-14 py-20 sm:py-28">
          <div className="absolute -top-24 -right-16 h-72 w-72 rounded-full bg-brand-primaryhover/60 blur-3xl" />
          <div className="absolute -bottom-24 -left-16 h-72 w-72 rounded-full bg-brand-dark/30 blur-3xl" />

          <div className="relative max-w-3xl">
            <span className="text-xs uppercase tracking-[0.25em] text-brand-inverse/70">
              Ora in rilascio su Android
            </span>
            <h2 className="mt-6 font-display font-medium tracking-tight leading-[0.95] text-brand-inverse text-4xl sm:text-6xl md:text-7xl">
              <RevealText
                inView
                lines={["Porta la sicurezza", "sempre con te."]}
              />
            </h2>
            <p className="mt-6 text-brand-inverse/80 text-base md:text-lg leading-relaxed max-w-xl">
              Scarica Safe(H)er e attiva la tua rete di protezione. Android è in
              rilascio graduale su Google Play; la versione iOS arriverà presto.
            </p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: 0.2 }}
              className="mt-10 flex flex-col sm:flex-row gap-4"
            >
              <StoreButton
                href="#scarica"
                icon={Play}
                top="Disponibile su"
                bottom="Google Play"
                testid="googleplay-btn"
              />
              <span
                data-testid="appstore-btn"
                className="inline-flex items-center gap-3 rounded-2xl border border-brand-inverse/25 text-brand-inverse/70 px-6 py-4 min-w-[200px] cursor-default"
              >
                <Apple size={26} className="shrink-0" />
                <span className="flex flex-col leading-none text-left">
                  <span className="text-[11px] text-brand-inverse/50">
                    Presto su
                  </span>
                  <span className="text-lg font-display tracking-tight">
                    App Store
                  </span>
                </span>
              </span>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Download;
